export { default } from './useCoursesDependencies';
